/* @flow */
// import moment from 'moment';
import * as t from './actionTypes';

const InitialState = {
  userId: null,
  accessToken: null,
};

export default function users(state: Object = InitialState, action: Object) {
  switch (action.type) {
    case t.SET_CURRENT_USER:
      return {
        ...state,
        userId: action.userId,
        accessToken: action.accessToken,
      };
    case t.LOGOUT:
      return {
        ...state,
        ...InitialState,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/current-user/reducer.js